/* eslint-disable @next/next/no-img-element */
import { Suspense, lazy } from "react";

import { Progress, Spin } from "antd";

import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import { User } from "shared/providers/context/types/auth-context";
import componentLoader from "shared/utils/componentLoader";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";

import {
  ContentUserInfo,
  PopoverAnt,
  UserProgressContainer,
  UserProgressContent,
} from "./styles";

const MenuProfile = lazy(() => componentLoader(() => import("./menuProfile")));

interface UserProgressProps {
  image?: string;
  autoHeight?: boolean;
  topbar?: boolean;
  zeroMarginTop?: boolean;
  noPointer?: boolean;
  mobile?: boolean;
  mini?: boolean;
  percentLabel?: number | string;
  sizeDefault?: boolean;
  overflowImage?: boolean;
  userSession?: User;
  sizeText?: string;
  popover?: boolean;
  percent?: number | string;
  onClick?: (e) => void;
}

export default function UserProgress({
  image,
  autoHeight,
  topbar = false,
  zeroMarginTop,
  noPointer = false,
  mobile,
  mini = false,
  percentLabel,
  sizeDefault,
  overflowImage = false,
  userSession,
  sizeText,
  onClick,
  ...props
}: UserProgressProps) {
  const { loggedUser: user } = useAuthContext();

  function userInitials(item: User, photo: string, size?: string) {
    try {
      if (!photo) {
        if (item?.display_name.split(" ").length === 1) {
          return (
            <ContentUserInfo
              className="content-user-info gx-bg-primary"
              size={size === "large" && "true"}
            >
              <div className="user-progress-initials">
                <SimpleUserInitialsName fullName={item?.display_name} />
              </div>
            </ContentUserInfo>
          );
        }

        return (
          <ContentUserInfo
            className="content-user-info gx-bg-cyan"
            size={size === "large" && "true"}
          >
            <div className="user-progress-initials">
              <SimpleUserInitialsName fullName={item?.display_name} />
            </div>
          </ContentUserInfo>
        );
      }
    } catch (error) {
      return (
        <ContentUserInfo
          className="content-user-info gx-bg-cyan"
          sizeText={sizeText}
          size={size === "large"}
        >
          <span>not user</span>
        </ContentUserInfo>
      );
    }

    return <img alt="" src={photo} />;
  }

  return (
    <>
      {topbar ? (
        <PopoverAnt
          placement="bottomRight"
          trigger="click"
          content={
            <Suspense fallback={<Spin />}>
              <MenuProfile />
            </Suspense>
          }
        >
          <UserProgressContainer
            noPointer={noPointer}
            overflowImage={overflowImage}
            sizeDefault={sizeDefault}
            autoHeight={autoHeight}
            mobile={mobile}
            topbar={topbar}
          >
            {percentLabel && <p>{`${percentLabel}%`}</p>}
            <UserProgressContent
              mini={mini}
              sizeDefault={sizeDefault}
              mobile={mobile}
              topbar={topbar}
              {...props}
            >
              <Progress
                strokeColor={{ "0%": "#108ee9", "100%": "#87d068" }}
                className="progress-bar"
                type="circle"
                percent={0}
              />

              {userInitials(user, image)}
              <div className="item white-bg" />
            </UserProgressContent>
          </UserProgressContainer>
        </PopoverAnt>
      ) : (
        <UserProgressContainer
          noPointer={noPointer}
          overflowImage={overflowImage}
          sizeDefault={sizeDefault}
          mobile={mobile}
          topbar={topbar}
          zeroMarginTop={zeroMarginTop}
          onClick={onClick}
          {...props}
        >
          {percentLabel && <p>{`${percentLabel}%`}</p>}
          <UserProgressContent
            mini={mini}
            sizeDefault={sizeDefault}
            mobile={mobile}
          >
            <Progress
              strokeColor={{ "0%": "#108ee9", "100%": "#87d068" }}
              className="item progress-bar"
              type="circle"
              percent={0}
            />

            {userInitials(userSession, image, "large")}
            <div className="item white-bg" />
          </UserProgressContent>
        </UserProgressContainer>
      )}
    </>
  );
}
